import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { CommonService } from './common.service';
import { DocumentFileRequest } from '../../common-components/document-file/document-file-request';
import { environment } from '../../../environments/environment';
import { IconList } from '../../../iconlist';
import { ToasterService } from './toaster.service';
import { of } from 'rxjs';
import { RootPaths } from '../../../appconfig';

@Injectable()
export class DocumentsService {
  saveDocument(documentFile: any) {
    throw new Error('Method not implemented.');
  }
  constructor(private restService: RestService, private commonService: CommonService, private toasterService: ToasterService) {

  }

  /**
   * This will sets the config for displaying document file upload component
   * @param userId User Id for which document file has to be uploaded
   * @param documentSubTypeId Document Sub Type Id for which doucment file will be uploaded
   * @param picFor Title of document file upload component header
   * @param showDocumentNumber if document number text box has to be displayed or not
   * @param showDocumentDate if document date calendar has to be displayed or not
   * @returns returns object document file data object
   */
  setDocumentFileDataConfig(userId?: any, documentSubTypeId?: any, picFor?: any, showDocumentNumber?: any,
    showDocumentDate?: any, projectId?: any, reraPromoterId?: any, documentNumber?: any, index?: any) {
    return {
      "userId": userId,
      "documentSubTypeId": documentSubTypeId,
      "picFor": picFor,
      "showDocumentNumber": showDocumentNumber,
      "showDocumentDate": showDocumentDate,
      "projectId": projectId,
      "reraPromoterId": reraPromoterId,
      "documentNumber": documentNumber,
      "index": index //for file being uploaded for an array
    }
  }

  /**
   * Post Document Data
   * @returns Post API
   */
  postDocumentTemplateFile(data: any) {
    return this.restService.postData('document-processor/booking', data, false, true)
  }

  /**
   * Gets List of all documents of a user based on userId or Document sub type
   * @param userId Id of a user whose document's list has to be fetched (optional)
   * @param documentSubTypeId Id of a document sub type whose document's list has to be fetched (optional)
   * @returns returns list of documents
   */
  getFilterDocument(userId?: any, allotmentId?: any, bookingId?: any, projectId?: any, landKhasraId?: any,
    documentSubTypeIds?: any, documentTypeIds?: any, isActive: boolean = true, reraPromoterId: any = null, explorationId: any = null) {
    let localUrl: string = 'document-processor';
    const queryParams: string[] = [];

    if (userId)
      queryParams.push(`userId=${userId}`)

    if (allotmentId)
      queryParams.push(`allotmentId=${allotmentId}`)

    if (bookingId)
      queryParams.push(`bookingId=${bookingId}`)

    if (explorationId)
      queryParams.push(`explorationId=${explorationId}`)

    if (projectId)
      queryParams.push(`projectId=${projectId}`)

    if (landKhasraId)
      queryParams.push(`landKhasraId=${landKhasraId}`)

    if (reraPromoterId)
      queryParams.push(`reraPromoterId=${reraPromoterId}`)

    //it may be possible that we need to fetch multiple DocumentType documents together
    if (documentSubTypeIds) {
      if (Array.isArray(documentSubTypeIds)) {
        documentSubTypeIds.forEach(docSubTypeId => {
          queryParams.push(`documentSubTypeId=${docSubTypeId}`)
        });
      }
      else
        queryParams.push(`documentSubTypeId=${documentSubTypeIds}`)
    }

    //it may be possible that we need to fetch multiple DocumentsubType documents together
    if (documentTypeIds) {
      if (Array.isArray(documentTypeIds)) {
        documentTypeIds.forEach(docTypeId => {
          queryParams.push(`documentTypeId=${docTypeId}`)
        });
      }
      else
        queryParams.push(`documentTypeId=${documentTypeIds}`)
    }

    queryParams.push(`isActive=${isActive}`)

    if (queryParams.length > 0) {
      localUrl += `?${queryParams.join('&')}`;
    }
    // localUrl = userId ? localUrl + '?userId=' + userId : localUrl
    // localUrl = allotmentId ? ((userId) ? localUrl + '&allotmentId=' + allotmentId : localUrl + '?allotmentId=' + allotmentId) : localUrl
    // localUrl = projectId ? ((userId || allotmentId) ? localUrl + '&projectId=' + projectId : localUrl + '?projectId=' + projectId) : localUrl
    // localUrl = landKhasraId ? ((userId || allotmentId || projectId) ? localUrl + '&landKhasraId=' + landKhasraId : localUrl + '?landKhasraId=' + landKhasraId) : localUrl
    // localUrl = documentSubTypeId ? ((userId || allotmentId || projectId || landKhasraId) ? localUrl + '&documentSubTypeId=' + documentSubTypeId : localUrl + '?documentSubTypeId=' + documentSubTypeId) : localUrl
    // localUrl = documentTypeId ? ((userId || allotmentId || projectId || landKhasraId || documentSubTypeId) ? localUrl + '&documentTypeId=' + documentTypeId : localUrl + '?documentTypeId=' + documentTypeId) : localUrl
    // localUrl = isActive ? ((userId || allotmentId || projectId || landKhasraId || documentTypeId || documentSubTypeId) ? localUrl + '&isActive=' + isActive : localUrl + '?isActive=' + isActive) : localUrl

    return this.restService.getData(localUrl);
  }

  /**
   * Update Document Data
   * @returns Update API
   */
  PostDocumentFile(data: FormData) {
    return this.restService.postData('document-processor/store/save', data, false, true)
  }

  /**
   * delete document by document id, this will delete the document record from database as well (soft delete) as the file from storage (Azure)
   * @param documentId id of document to be deleted
   * @returns 
   */
  DeleteDocumentById(documentId: any) {
    let url = 'document-processor/store/delete?documentId=' + documentId;
    return this.restService.delete(url);
  }

  /**
 * Update Document Data
 * @returns Update API
 */
  PostDocumentFiles(data: FormData[]) {
    return this.restService.postData('document-processor/store/save', data, false, true)
  }


  /**
   * Dumps the document file data to storage without saving document details in database, this is used for temporary storage of document file until user submits the form and then same file can be moved to final storage location and document details can be saved in database with reference of that file
   * @param data Files data to be dumped in storage
   * @returns 
   */
  DumpDocumentFiles(data: any) {
    return this.restService.postData('document-processor/store/savedump', data, false, true)
  }


  GetDumpDocumentFiles(entityType: any, entityId: any, uploadedBy: any) {
    let url = 'document-processor/store/documentDump?entityType=' + entityType + '&entityId=' + entityId + '&uploadedBy=' + uploadedBy;
    return this.restService.getData(url)
  }


  /**
   * Gets document dump details by document ID (name, path, ext, etc.)
   * @param documentId Id of the document dump to fetch
   * @returns Observable with document dump details
   */
  getDocumentDumpById(documentId: number) {
    // Consistent with other dump-related endpoints
    return this.restService.getData('document-processor/store/documentDump/' + documentId);
  }


  DeleteDumpDocumentFiles(documentId: any) {
    let url = 'document-processor/store/documentDump';
    return this.restService.deleteData(url, documentId)
  }

  /**
   * Patch document dump description
   * @param documentId Id of document dump to be updated
   * @param description New description for the document
   * @returns PATCH API
   */
  patchDocumentDumpDescription(documentId: any, description: string) {
    let url = 'document-processor/store/documentDump';
    const data = { description: description };
    return this.restService.patchData(url, documentId, data)
  }

  /**
   * Patch description for document or report
   * @param id Id of document or report to be updated
   * @param description New description
   * @param type Type of item: 'document' or 'report'
   * @returns PATCH API
   */
  patchDescriptionByType(id: any, description: string, type: 'document' | 'report' = 'document') {
    let url: string;

    if (type === 'document') {
      url = 'document-processor/store/documentDump';
    } else {
      url = 'document-processor/store/patch-description';
    }

    const data = { description: description };
    return this.restService.patchData(url, id, data)
  }

  /**
 * Update Document Data
 * @returns Update API
 */
  UpdateDocumentFile(id?: any, data?: FormData) {
    return this.restService.updateData('document-processor/store/update', id, data, true)
  }


  /**
 * Gets the bytes of a document file by document id
 * @param documentId Id of document whose byte has to be fetched
 */
  downloadtDocumentById(documentId: number = 0, documentNumber: any = ""): any {
    let apiUrl = "";
    if (documentId != 0) {
      apiUrl = "documentId=" + documentId;
    } else if (documentNumber != "") {
      apiUrl = "documentNumber=" + documentNumber;
    }
    let url = 'document-processor/store/download-file?' + apiUrl

    // let url = this.commonService.setDataUrl('document-processor/store/download-byte?documentId=' + documentId,
    //   environment.dummyDbPath + 'documentfile.json')
    return this.restService.getData(url)
  }

  /**
   * Gets the bytes of a document file by document id
   * @param documentId Id of document whose byte has to be fetched
   */
  getDocumentBytesById(documentId: number = 0, documentNumber: any = "", sourceType?: string): any {
    let apiUrl = "";
    if (documentId != 0) {
      apiUrl = "documentId=" + documentId;
    } else if (documentNumber != "") {
      apiUrl = "documentNumber=" + documentNumber;
    }
    if (sourceType) {
      apiUrl += (apiUrl ? "&" : "") + "sourceType=" + sourceType;
    }
    let url = 'document-processor/store/download-byte?' + apiUrl
    return this.restService.getData(url)
  }

  /**
   * Gets the bytes of a document file by Folder Path
   * @param documentId Id of document whose byte has to be fetched
   */
  getDocumentBytesByFolderPath(folderPath: any = ""): any {
    if (folderPath != "") {
      let url = 'document-processor/store/download-byte-from?folderPath=' + folderPath
      return this.restService.getData(url)
    }
    // let url = this.commonService.setDataUrl('document-processor/store/download-byte?documentId=' + documentId,
    //   environment.dummyDbPath + 'documentfile.json')
  }

  /**
   *
   * @param docFileData Document file data object, uploaded by a user
   * @param showUploadMessage flag to show display message of file upload success
   */
  saveDoucmentFile(docFileData: any, showUploadMessage: boolean = true) {

    //set the document data to form object as document post/save APIs take data in form object form rather than JSON
    let frmRequest = new DocumentFileRequest(this.commonService)
    let frm = frmRequest.setDocumentFormData(docFileData)

    //Post/Update the document file based on operation mode (if document Id available then edit else Add).
    if (!docFileData?.documentId && docFileData?.documentId == undefined)
      this.PostDocumentFile(frm).subscribe((res: any) => {
        if (showUploadMessage)
          this.toasterService.showSuccess("File Uploaded Successfully.")
      })
    else
      this.UpdateDocumentFile(docFileData?.documentId, frm).subscribe((res: any) => {
        this.toasterService.showSuccess(docFileData?.picFor + " File Uploaded Successfully.")
      })
  }


  /**
   *
   * @param docFileData Document file data array object, containing multiple files to be uploaded
   * @param showUploadMessage flag to show display message of file upload success
   */
  saveMultipleDoucmentFiles(docFileData: any[], showUploadMessage: boolean = true) {

    //set the document data to form object as document post/save APIs take data in form object form rather than JSON
    //since multiple files are to be uploaded, we need to prepare array of form data objects for create and update separately
    //as few files may be in create mode and few in update mode
    let docArrayCreate: any[] = [];
    let docArrayUpdate: any[] = [];

    docFileData.forEach(docData => {
      let frmRequest = new DocumentFileRequest(this.commonService)
      let frm = frmRequest.setDocumentFormData(docData)
      //if current file as document id then it will be updated otherwise created
      if (!docData?.documentId && docData?.documentId == undefined)
        docArrayCreate.push(frm)
      else
        docArrayUpdate.push(frm)
    });

    //Post/Update the document file based on operation mode (if document Id available then edit else Add).
    if (docArrayCreate.length > 0)
      this.PostDocumentFiles(docArrayCreate).subscribe((res: any) => {
        if (showUploadMessage)
          this.toasterService.showSuccess("Files Uploaded Successfully.")
      })
    //here update feature is stopping as we need to implement update API with id in request object only so that direct array of dataobject can be passed like create
    // else
    //   this.UpdateDocumentFile(docFileData?.documentId, frm).subscribe((res: any) => {
    //     this.toasterService.showSuccess(docFileData?.picFor + " File Uploaded Successfully.")
    //   })
  }

  /**
   * Gets the list of all file names in a specified folder on cloud (Azure)
   * @param folderPath Folder path whose files has to be fetched
   * @returns returns list of all file names
   */
  getDocumentListInFolder(folderPath?: string) {
    if (!folderPath || folderPath == "") {
      return of([]); // safeguard
    }
    const apiUrl = `document-processor/store/list-files?folderPath=${folderPath}`;
    return this.restService.getData(apiUrl);
  }

  /**
   * Gets the list of all sub folders names in a specified folder on cloud (Azure)
   * @param folderPath Folder path whose sub folder has to be fetched
   * @returns returns list of all file names
   */
  getSubFolderListInFolder(folderPath: string) {
    let apiUrl: string = "document-processor/store/list-dir?folderPath=" + folderPath
    return this.restService.getData(apiUrl)
  }

  getDocumentType() {
    return this.restService.getData('document-type');
  }


  /**
   * Filters the document sub type based on given parameters
   * @param id document sub type id (optional)
   * @param documentTypeId document type id for which document sub type has to be filtered (optional)
   * @param isActive if true then only active document sub type will be returned (optional, default is true)
   * @returns returns list of document sub types based on given filters
   */
  filterDocumentSubType(id: any, documentTypeId: any, isActive: boolean = true) {
    var localUrl = 'document-sub-type?isActive=' + isActive;
    if (id)
      localUrl += '&id=' + id;
    if (documentTypeId)
      localUrl += '&documentTypeId=' + documentTypeId;
    return this.restService.getData(localUrl);
  }

  filterMultiDocumentSubType(ids: any[], documentTypeId: any[], isActive: boolean = true) {
    var localUrl = 'document-sub-type/multi?isActive=' + isActive;
    if (ids && ids.length > 0) {
      if (Array.isArray(ids)) {
        ids.forEach(docId => {
          localUrl += '&Id=' + docId;
        });
      }
    }

    if (documentTypeId && documentTypeId.length > 0) {
      if (Array.isArray(documentTypeId)) {
        documentTypeId.forEach(docTypeId => {
          localUrl += '&documentTypeId=' + docTypeId;
        });
      }
    }
    return this.restService.getData(localUrl);
  }

  getOperationIcon(documentPic: any) {
    return (documentPic == null ? environment.assetsImagePath + IconList.AddIcon : environment.assetsImagePath + IconList.EditIcon);
  }

  /**
   * Converts the base64 string to file object
   * @param base64String basre64 string of file
   * @returns returns file object
   */
  convertBase64ToFile(base64WithHeader: string, fileType?: string): string {
    const base64String = base64WithHeader?.includes(',')
      ? base64WithHeader.split(',')[1]
      : base64WithHeader;

    const byteCharacters = atob(base64String); // decode base64 string
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    // Use provided fileType, don't ignore it!
    const blob = new Blob([byteArray], { type: fileType || 'data/image' });
    return this.createObjectURLFromBlob(blob);
  }

  /**
   * Creates an Object URL from a Blob to be used for previewing files directly
   * @param blob Blob data
   * @returns Object URL string pointing to the blob in browser memory
   */
  createObjectURLFromBlob(blob: Blob): string {
    return window.URL.createObjectURL(blob);
  }

  /**
   * Efficiently converts a large Base64 string to a Blob Object URL using the native Fetch API.
   * This avoids the browser memory crashes associated with atob() on large files.
   * @param base64Data The base64 string (can include quotes or data URI prefix)
   * @param mimeType The expected MIME type of the file
   * @returns A promise that resolves to the Object URL
   */
  async convertBase64ToObjectURL(base64Data: string, mimeType: string): Promise<string> {
    if (!base64Data) return '';
    
    // Clean up quotes if present (e.g. if API returned a raw JSON string)
    if (base64Data.startsWith('"') && base64Data.endsWith('"')) {
      base64Data = base64Data.substring(1, base64Data.length - 1);
    }
    
    // Remove data URI prefix if it exists
    if (base64Data.includes(',')) {
      base64Data = base64Data.split(',')[1];
    }
    
    try {
      // Use native fetch to convert base64 to Blob efficiently
      const fetchResponse = await fetch(`data:${mimeType};base64,${base64Data}`);
      const blob = await fetchResponse.blob();
      return window.URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error converting base64 to blob via fetch:', error);
      // Fallback to atob if fetch fails
      const byteString = atob(base64Data);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeType });
      return window.URL.createObjectURL(blob);
    }
  }

  /**
   * Downloads the file from base64 string
   * @param base64String base64 string of file
   * @param fileName name of file to be downloaded
   */
  downloadFileFromBase64(base64String: string, fileName: string): void {
    //first convert base64 string to file object
    const url = this.convertBase64ToFile(base64String);

    // Create a link element, set its href to the file URL, and trigger a click to download
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'downloaded-file';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Downloads the file from server by providing file path, this is used when we don't 
   * want to fetch the file bytes in frontend and want to directly download the file 
   * from server by providing file path. This method returns blob data.
   * @param filePath Path of the file to be downloaded
   * @returns Observable with the blob file data
   */
  downloadFileByFilePath(filePath: string) {
    // Encode filePath to handle special characters like &, %, etc.
    let localUrl: string = 'document-processor/store/download-file-by-path?filePath=' + encodeURIComponent(filePath);
    return this.restService.getBlobData(localUrl);
  }

  /**
   * Handles the blob response from download API and triggers file download
   * @param blobResponse Blob data returned from download API
   * @param fileName Name of the file to be downloaded (optional, extracted from content-disposition if not provided)
   */
  downloadBlobFile(blobResponse: Blob, fileName?: string): void {
    // If fileName not provided, use default name
    const downloadFileName = fileName || 'downloaded-file';

    // Create a blob URL from the response
    const blobUrl = window.URL.createObjectURL(blobResponse);

    // Create a temporary link element and trigger download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = downloadFileName;

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release the blob URL memory
    window.URL.revokeObjectURL(blobUrl);
  }

  /**
   * Deletes a file or folder by path from Azure storage
   * @param fileOrFolderPath Path of the file or folder to delete
   * @returns Observable with response from the server
   */
  deleteFileOrFolderByPath(fileOrFolderPath: string) {
    const apiUrl = `document-processor/store/deleteByPath?fileOrFolderPath=${encodeURIComponent(fileOrFolderPath)}`;
    return this.restService.delete(apiUrl);
  }

  getKMLFilePathFromUrl(url: string): string {
    url = decodeURIComponent(url);
    const path = RootPaths.KMLFiles + "/" + url.substring(url.indexOf('filePath') + 9, url.indexOf('&x='))
    return path;
  }

  /**
   * Log document access (view/download) for analytics tracking
   * @param documentId The document ID (optional, either documentId or documentDumpId required)
   * @param documentDumpId The document dump ID (optional, either documentId or documentDumpId required)
   * @param accessType Type of access: 'view' or 'download'
   * @returns Observable with the access log response
   */
  logDocumentAccess(documentId: number | null, documentDumpId: number | null, accessType: 'view' | 'download') {
    const request = {
      documentId: documentId,
      documentDumpId: documentDumpId,
      viewed: accessType === 'view',
      downloaded: accessType === 'download'
    };

    return this.restService.postData('document-processor/log-access', request, false);
  }

  /**
   * Get access statistics for a document or report
   * Shows view/download counts grouped by user
   * @param documentId Document ID (optional, for uploaded documents)
   * @param documentDumpId Document Dump ID (optional, for temporary uploads/reports)
   * @returns Observable with access statistics grouped by user
   */
  getDocumentAccessStats(documentId?: number, documentDumpId?: number) {
    let queryParams = '';

    if (documentId) {
      queryParams += `documentId=${documentId}`;
    }

    if (documentDumpId) {
      queryParams += (queryParams ? '&' : '') + `documentDumpId=${documentDumpId}`;
    }

    const url = 'document-processor/access-stats' + (queryParams ? '?' + queryParams : '');
    return this.restService.getData(url);
  }
}